import { useMediaQuery } from '@mantine/hooks'
import React, { type ReactNode } from 'react'

import { findReactChildrenByDisplayName } from '@flecto/utils/src/Window/findReactChildrenByDisplayName'

import { ContentWithSidebarMobile } from '../ContentWithSidebarMobile'

export function useFilterChildren(children: ReactNode) {
  const isMobile = useMediaQuery('(max-width: 760px)')

  let headerChildren: ReactNode = null
  let contentChildren: ReactNode = null

  if (Array.isArray(children)) {
    headerChildren = findReactChildrenByDisplayName(children, [
      '@mantine/core/MediaQuery',
      'MediaQuery',
      'PageTitle',
      'PageBack',
      'PageClose',
      'PageActions',
      'PageDescription',
    ])

    contentChildren = findReactChildrenByDisplayName(children, [
      'PageContent',
      'PageSidebar',
    ])

    if (isMobile) {
      const content = children.find(
        (node) => node?.type?.displayName === 'PageContent'
      )
      const sidebar = children.find(
        (node) => node?.type?.displayName === 'PageSidebar'
      )

      if (Boolean(content) && Boolean(sidebar)) {
        contentChildren = (
          <ContentWithSidebarMobile content={content} sidebar={sidebar} />
        )
      }
    }
  } else {
    contentChildren = children
  }

  return { headerChildren, contentChildren }
}
